import React from 'react';
import { Icon, IconsEnum } from 'components/Icons';
import { Leaf, ScommesseLeafItem } from 'components/scommesseTipo/components/cells';
import { useInfoAggiuntivaIndex, useIsAtLeastOneActive } from 'features/sport/hooks';

import { ScommesseQuoteListItemProps } from 'components/scommesseTipo/components/scommesseQuoteList';
import classNames from 'classnames';
import styles from './ScommesseQuoteList.module.scss';
import useWindowSize from 'hooks/useWindowSize';

export const InfoAggiuntivaWithEsitoListItem = ({
  itemKey,
  disabled,
  isSelected,
  isBilanciata,
  scommessaKey,
  infoAggiuntivaKey,
  onClick,
}: ScommesseQuoteListItemProps) => {
  const hasValidEsiti = useIsAtLeastOneActive([itemKey], true);
  const infoAggIndex = useInfoAggiuntivaIndex(itemKey);
  const { esitoKeyList } = infoAggIndex ?? {};
  const { isMobile } = useWindowSize();

  const handleClick = (itemKey) => {
    onClick(itemKey);
    if (isMobile) document.getElementById('linesCloser')?.click();
  };

  return (
    <button
      type="button"
      className={classNames(styles.btn, { [styles.active]: isSelected, [styles.hidden]: !hasValidEsiti })}
      disabled={disabled}
      data-testid={`InfoAggiuntiva-WithEsito-ListItem-${itemKey}`}
      onClick={() => handleClick(itemKey)}
    >
      <span className={classNames(styles.check)}>
        {isSelected && <Icon iconId={IconsEnum.CHECK} className={styles.checkIcon} color="var(--color-primary)" />}
      </span>
      <span className={classNames(styles.left, styles.highlighted, { [styles.balance]: isBilanciata })}>
        {
          <Leaf
            scommessaKey={scommessaKey}
            infoAggiuntivaKey={infoAggiuntivaKey}
            itemKey={infoAggiuntivaKey}
            type={ScommesseLeafItem.InfoAggiuntivaWithEsito}
          />
        }
      </span>
      <ul className={styles.list}>
        {esitoKeyList?.map((esitoKey) => (
          <li key={esitoKey} className={classNames(styles.singleItem)}>
            <Leaf
              scommessaKey={scommessaKey}
              infoAggiuntivaKey={infoAggiuntivaKey}
              itemKey={esitoKey}
              type={ScommesseLeafItem.Esito}
            />
          </li>
        ))}
      </ul>
    </button>
  );
};